/**
 * Usage
 * 
 * 
import CustomDrawer from 'src/components/Drawer';

interface Props {}
const DrawerMenu = React.forwardRef((props: Props, ref: any) => {

  const refDrawer = React.useRef<any>(null);

  React.useImperativeHandle(ref, () => ({
    open: () => {
      refDrawer?.current.open()
    },
    close: () => {
      refDrawer?.current.close()
    }
  }))

  return (
    <CustomDrawer
      contentPadding={0}
      placement='left'
      title="Drawer"
      ref={refDrawer}>
      <div style={{
        height: '100%'
      }}>
        Content
      </div>
    </CustomDrawer>
  );
})
 */

import * as React from 'react';
import { useState } from 'react';

// rsuite
import { Drawer, DrawerProps } from 'rsuite';

// hooks
import useMedia from '../../hooks/useMedia';


interface Props extends DrawerProps {
  title: string
  children: React.ReactNode
  // placement?: 'left' | 'right' | 'top' | 'bottom'
  // size?: 'xs' | 'sm' | 'md' | 'lg' | 'full'
  contentPadding?: number
  onClose?: () => void
}

const CustomDrawer = React.forwardRef(({ title, children, contentPadding, onClose, ...props }: Props, ref: any) => {

  const media = useMedia()

  const [open, setOpen] = useState(false);

  /**
   * The component instance will be extended
   * with whatever you return from the callback passed
   * as the second argument
   */
  React.useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true)
    },
    close: () => {
      setOpen(false)
    }
  }))

  // Render
  const drawerSize = media.up.sm ? props.size || 'xs' : 'full'

  return (
    <>
      {/* <Button onClick={() => setOpenWithHeader(true)}>Open with header</Button> */}

      <Drawer
        {...props}
        size={drawerSize}
        open={open}
        onClose={() => {
          setOpen(false)
          if (onClose) {
            onClose()
          }
        }}>
        <Drawer.Header>
          <Drawer.Title>
            {title}
          </Drawer.Title>
          {/* <Drawer.Actions>
            <Button onClick={() => setOpenWithHeader(false)}>Cancel</Button>
            <Button onClick={() => setOpenWithHeader(false)} appearance="primary">
              Confirm
            </Button>
          </Drawer.Actions> */}
        </Drawer.Header>
        <Drawer.Body style={{ padding: contentPadding }}>
          {open && children}
        </Drawer.Body>
      </Drawer>
    </>
  );
});


export default CustomDrawer;